import { ensureElement } from '../utils/utils';
import { Component } from './base/Components';
export class CardView extends Component {
    constructor(blockName, container, actions) {
        super(container);
        this.blockName = blockName;
        this._title = ensureElement(`.${blockName}__title`, container);
        this._button = container.querySelector(`.${blockName}__button`);
        this._price = container.querySelector(`.${blockName}__price`);
        if (actions === null || actions === void 0 ? void 0 : actions.onClick) {
            if (this._button) {
                this._button.addEventListener('click', actions.onClick);
            }
            else {
                container.addEventListener('click', actions.onClick);
            }
        }
    }
    set id(value) {
        this.container.dataset.id = value;
    }
    set title(value) {
        this.setText(this._title, value);
    }
    set price(value) {
        if (value === null) {
            this.setText(this._price, 'Бесценно');
        }
        else {
            this.setText(this._price, `${value} синапсов`);
        }
    }
}
export class CatalogItem extends CardView {
    constructor(container, actions) {
        super('card', container, actions);
        this._image = ensureElement(`.${this.blockName}__image`, container);
        this._category = container.querySelector(`.${this.blockName}__category`);
    }
    set image(value) {
        this.setImage(this._image, value, this.title);
    }
    set category(value) {
        this.setText(this._category, value);
        switch (value) {
            case 'софт-скил':
                this._category.style.backgroundColor = '#83FA9D';
                break;
            case 'другое':
                this._category.style.backgroundColor = '#FAD883';
                break;
            case 'дополнительное':
                this._category.style.backgroundColor = '#B783FA';
                break;
            case 'кнопка':
                this._category.style.backgroundColor = '#83DDFA';
                break;
            case 'хард-скил':
                this._category.style.backgroundColor = '#FAA083';
                break;
            default:
                this._category.style.backgroundColor = '#83FA9D';
        }
    }
}
export class ProductCard extends CatalogItem {
    constructor(container, actions) {
        super(container, actions);
        this._description = container.querySelector(`.${this.blockName}__text`);
        this.buttonAddToCart = container.querySelector('.card__button');
        if (this.buttonAddToCart && (actions === null || actions === void 0 ? void 0 : actions.onClick)) {
            this.buttonAddToCart.addEventListener('click', actions.onClick);
        }
    }
    set description(value) {
        this.setText(this._description, value);
    }
    disableAddButton(disable) {
        if (this.buttonAddToCart) {
            this.buttonAddToCart.disabled = disable;
        }
    }
}
export class BasketItem extends CardView {
    constructor(container, actions) {
        super('card', container, actions);
        this._index = container.querySelector(`.basket__item-index`);
    }
    set index(value) {
        this.setText(this._index, String(value));
    }
}
